/**
 * Amazon Payment Script
 */

(function() {
    'use strict';

    const PAYMENT_MONITOR_PREFIX = '[PaymentMonitoring:Amazon] ';

    function logPaymentEvent(eventType, details) {
        const message = PAYMENT_MONITOR_PREFIX + eventType + ' | ' + JSON.stringify(details);
        console.warn(message);
    }

    window.amazonPaymentMonitoring = {
        logPaymentEvent
    };

})();

$(document).ready(function () {
    $("#checkoutOptionsContainer").change(function() {
        if ($('#amazon').prop('checked') === true) {
            $(".checkout-button").css({'visibility':'hidden','display':'none'});
            if ($("#amazonButtonVariation").val() === "ORIGINAL") {
                $(".amazon-button").css({'visibility':'hidden','display':'none'});
                $(".amazonButtonOriginal").css({'visibility':'visible','display':'inline-block'});
            } else {
                $(".amazon-button").css({'visibility':'visible','display':'inline-block'});
                $(".amazonButtonOriginal").css({'visibility':'hidden','display':'none'});
            }
        } else {
            $(".checkout-button").css({'visibility':'visible','display':'inline-block'});
            $(".amazon-button").css({'visibility':'hidden','display':'none'});
            $(".amazonButtonOriginal").css({'visibility':'hidden','display':'none'});
        }
    });

    $(".amazonButtonOriginal").click(function () {
        $('#AmazonPayButton').trigger('click');
    });
});